// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "treatment_agent".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "treatment_agent" table (1:1 with a DB row, on the wire). */
export const treatmentAgentAtomSchema = z.object({
    slug: z.string(),
    displayName: z.string(),
    techniqueSlug: z.string(),
    aliases: z.array(z.string()),
    requiresExactMatch: z.boolean(),
    isActive: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=treatmentAgent.js.map